/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import paxios from "./paxios";
import { setupCache } from "axios-cache-adapter";
import i18n from "@/common/multilanguage/i18n";
import { subdomains } from "@/common/consts";
import { getCurrentSubdomain } from "@/common/functions";

const API = process.env.WORDS_API;
const INDEX_API = process.env.WORD_INDEX_API;

const cache = setupCache({
    debug: process.env.NODE_ENV !== "production"
});

const resource = paxios.create({
    baseURL: API,
    adapter: cache.adapter
});
const indexResource = paxios.create({
    baseURL: INDEX_API,
    adapter: cache.adapter
});

const currentLocale = i18n.locale;

export default {
    getSections: slug => {
        return resource.get(`/${slug}/sections`);
    },
    getMentions: (slug, limit) => {
        const params = limit ? `?limit=${limit}` : ``;
        return resource.get(`/${slug}/mentions${params}`);
    },
    getNearbyWords: (slug, limit) => {
        const params = limit ? `?limit=${limit}` : ``;

        return resource.get(`/${slug}/nearby-words${params}`).then(
            res => {
                let data = res.data.data;
                data.nearby_words.push({
                    title: slug,
                    url: null
                });
                data.nearby_words.sort((a, b) => {
                    if (a.title < b.title) return -1;
                    if (a.title > b.title) return 1;
                    return 0;
                });
                return Promise.resolve(data);
            },
            err => Promise.reject({})
        );
    },
    getNearSynonyms: slug => {
        return resource.get(`/${slug}/nearby-words/thesaurus`).then(
            res => {
                let data = res.data.data;
                data.nearby_words.push({
                    title: slug,
                    url: null
                });
                data.nearby_words.sort((a, b) => {
                    if (a.title < b.title) return -1;
                    if (a.title > b.title) return 1;
                    return 0;
                });
                return Promise.resolve(data);
            },
            err => Promise.reject({})
        );
    },
    getRelatedArticles: (slug, limit) => {
        const params = limit ? `?limit=${limit}` : ``;
        return resource.get(`/${slug}/related${params}`);
    },
    getSentences: (slug, limit) => {
        const params = limit ? `?limit=${limit}` : ``;
        const language = currentLocale;
        return resource.get(`/${slug}/sentences/${language}${params}`);
    },
    getThesaurusRelation: localStorageWord => {
        const storedWord = localStorageWord.split("-");
        const word = storedWord[0];
        const pos = storedWord[1] == "null" ? null : storedWord[1];
        const sense = storedWord[2] == "null" ? null : storedWord[2];
        const slug = storedWord[3] == "null" ? null : storedWord[3];

        return resource.get(`/${word}/thesaurus`).then(
            response => {
                const { thesaurus } = response.data.data;
                const result = thesaurus
                    .filter(source => source.partsOfSpeech.length > 0)
                    .map(source => source.partsOfSpeech.filter(part => part.pos == pos))
                    .filter(part => part.length > 0)
                    .map(part =>
                        part[0].definitions.filter(def => {
                            return def.sense == sense;
                        })
                    )
                    .filter(el => el.length > 0)
                    .map(
                        el =>
                            el[0].synonyms.filter(synonym => synonym.word.slug == slug)[0].word
                                .relationId
                    )[0];
                return Promise.resolve(result);
            },
            err => Promise.reject({})
        );
    },
    getThesaurus: slug => {
        return resource.get(`/${slug}/thesaurus`).then(response => {
            const data = response.data.data;
            return Promise.resolve(data);
        });
    },
    getWordIndex: (limit, letter = "") => {
        const language = currentLocale;

        switch (getCurrentSubdomain()) {
            case subdomains.SENTENCES:
                return indexResource.get(`/sentences/${language}?limit=${limit}&letter=${letter}`, {
                    paxiosRetry: false
                });
            case subdomains.ES:
                return indexResource.get(`/sentences/${language}?limit=${limit}&letter=${letter}`, {
                    paxiosRetry: false
                });
            case subdomains.THESAURUS:
                return indexResource.get(`/thesaurus?limit=${limit}&letter=${letter}`, {
                    paxiosRetry: false
                });
        }
    },
    voteSentence: (slug, sentence, action) => {
        return resource.post(`/${slug}/sentences/vote`, {
            sentenceId: sentence.id,
            action
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/WordService.js